/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const clientEnumSchema = z.enum(["ios"]).describe("* `ios` - iOS-приложение");
